import React from 'react';
import { compose } from 'redux';
import { Route, Switch } from 'react-router-dom';
import WithMouseControls from 'components/HOCs/WithMouseControls';
import withBackSupport from 'components/HOCs/withBackSupport';
import ParentalControlPage from './ParentalControlPage';
import AgePage from './AgePage';
import PinCreateNewPage from './PinCreateNewPage';

const LoginRoutes = ({ match }) => {
  return (
    <Switch>
      <Route exact path={`${match.url}`} component={ParentalControlPage} />
      <Route exact path={`${match.url}/age`} component={AgePage} />
      {/* <Route exact path={`${match.url}/pin-protection`} component={PinProtectionPage} />*/}
      <Route exact path={`${match.url}/pin-create-new`} component={PinCreateNewPage} />
    </Switch>
  );
};

export default compose<React.FC>(WithMouseControls, withBackSupport)(LoginRoutes);
